import { useEffect } from 'react';
import { useCurrentUser } from '@kanda-libs/ks-frontend-services';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectors } from 'store';
import { URLS } from 'config';
import { sortJobs } from './Home-helpers';

interface ContainerProps {
  children: JSX.Element;
}

const Container = ({ children }: ContainerProps) => {
  const { push } = useHistory();
  const { isUserLoggedIn } = useCurrentUser();
  const jobs = useSelector(selectors.job.getEntitiesAsArray);
  const isLoading = useSelector(selectors.getIsLoading);

  /**
   * If the user is logged in, and they have jobs, redirect them to the first job
   */
  useEffect(() => {
    if (!isLoading && jobs?.length && jobs.length > 0) {
      const sortedJobs = sortJobs(jobs);

      push(URLS.job.replace(':id', sortedJobs[0].id));
    }
  }, [isUserLoggedIn, isLoading, jobs, push]);

  return children;
};

Container.displayName = 'Home-Container';

export default Container;
